import { digObject } from '@domain-group/javascript-utils'

import {
  Box, Image, ListItem, ListItemWithImage, Text,
} from '@domain-group/suit-theme'

import { EntitiesState } from '@redux/entities'

import type { ProviderModel } from '@models/types'

import type { UseProviderDeadlinesPayload } from '../../hooks/useProviderDeadlines'
import ProviderDeadlineListItem from '../ProviderDeadlineListItem'

type ProviderDeadlinesGroupProps = {
  agencyDeadlines: EntitiesState['agencyProviderDeadlineGroups'],
  callbacks: UseProviderDeadlinesPayload['callbacks'],
  provider: ProviderModel,
}

const ProviderDeadlinesGroup = (props: ProviderDeadlinesGroupProps) => {
  const {
    agencyDeadlines,
    callbacks: { mergeAndSortDeadlines },
    provider,
  } = props

  const agencyProviderDeadlines = digObject(agencyDeadlines[provider.id], 'deadlines')

  // @ts-expect-error TS2345
  const deadlines = mergeAndSortDeadlines(provider?.deadlines, agencyProviderDeadlines)

  const { phone, title } = provider || {}

  const imageUrl = digObject(provider, 'alternate_logo.thumb')

  return (
    <Box variant="white" marginBottom="large" flexDirection="column">
      <Box alignItems="center">
        <ListItemWithImage
          boxProps={{
            alignItems: 'center',
            border: 'none',
            display: 'flex',
            height: '50px',
            justifyContent: 'center',
            marginBottom: 0,
            width: '100px',
          }}
          imageComponent={imageUrl ? (
            <Image width={100} height={50} url={imageUrl} />
          ) : (
            <Box padding="small" justifyContent="center">
              <Text fontSize="xsmall" variant="ellipsis">
                {title}
              </Text>
            </Box>
          )}
        />

        <ListItem
          boxProps={{
            border: '1px solid',
            borderTop: 0,
            borderRight: 0,
            padding: 'large',
            alignItems: 'center',
          }}
          disableHover
        >
          <Box flexDirection="column" justifyContent="center">
            <Text fontSize="small">{title}</Text>

            <Box alignItems="center" fontSize="small" marginTop="medium">
              <Text color="bodyFontLightColor">{phone}</Text>
            </Box>
          </Box>
        </ListItem>
      </Box>

      <Box borderTop="1px solid" borderColor="lineColor" flexDirection="column">
        {deadlines.map(deadline => (
          <ProviderDeadlineListItem deadline={deadline} key={deadline.title} />
        ))}
      </Box>
    </Box>
  )
}

export default ProviderDeadlinesGroup
